import { dateFormat } from './dateFormat';

export function purchaseOrder(purchaseOrder: any) {
  if(!purchaseOrder) return purchaseOrder;
  return `${purchaseOrder._id} ${purchaseOrder.supplier.name} ${dateFormat(purchaseOrder.updatedAt)}`;
}